import {Component} from '@angular/core';
import {BreadcrumbService} from '../../../utilities/services/breadcrumb/breadcrumb.service';
import {Breadcrumb} from '../../../utilities/interfaces/Breadcrumb';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-breadcrumb',
  template: `
    <div #template>
      <ng-content></ng-content>
    </div>
    <div class="container" *ngIf="template.children.length == 0">
      <div class="nav-wrapper">
        <div class="breadcrumb" *ngFor="let route of breadcrumbs" [ngClass]="{'last': route.terminal}">
          <!-- disable link of last item -->
          <a href="" *ngIf="!route.terminal" [routerLink]="[route.url]">{{ route.displayName }}</a>
          <span *ngIf="route.terminal">{{ route.displayName }}</span>
        </div>
      </div>
    </div>
  `,
  styles: [`
    a {
      cursor: pointer;
      user-select: none;
      text-decoration: none;
      color: black;
    }
    a:hover {
      color: #69BE28;
    }
  `]
})
export class BreadcrumbComponent {
  breadcrumbs: Breadcrumb[];

  constructor(private breadcrumbService: BreadcrumbService) {
    breadcrumbService.breadcrumbChanged.subscribe((crumbs: Breadcrumb[]) => this.onBreadcrumbChange(crumbs));
  }

  private onBreadcrumbChange(crumbs: Breadcrumb[]) {
    this.breadcrumbs = crumbs;
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/layout/components/breadcrumb/breadcrumb.component.ts